import { useLogger } from "@sg-protect/federation-runtime/squide";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { MixpanelEventName } from "./mixpanelEventName.ts";
import { MixpanelProperty } from "./mixpanelProperty.ts";
import { useRouteTrackingName } from "./useRouteTrackingName.ts";
import { useTrackEvent } from "./useTrackEvent.ts";

export function PageViewTracker() {
    const location = useLocation();
    const track = useTrackEvent();
    const trackingName = useRouteTrackingName();
    const previousPath = useRef("");

    const logger = useLogger();
    const trackRef = useRef(track);

    // We don't want to add 'track' as a dependency to the main useEffect, otherwise it would trigger a page view event on everytime the track function changes ('track' is memoized, but can change for multiple reasons).
    //  By using a ref, we can ensure that we always have the latest 'track' function without causing unnecessary effects.
    useEffect(() => {
        trackRef.current = track;
    }, [track]);

    useEffect(() => {
        if (trackingName) {
            void trackRef.current(
                MixpanelEventName.PageViewed,
                {
                    [MixpanelProperty.Url]: window.location.pathname,
                    [MixpanelProperty.PreviousUrl]: previousPath.current
                },
                { keepAlive: true }
            );
        } else {
            logger.warning(
                `[tracking] No trackingName found for route '${window.location.pathname}'. Did you forget to add a 'trackingName' property to the route's 'handle' object?`
            );
        }

        previousPath.current = location.pathname;
    }, [trackingName, location.pathname, logger]);

    return null;
}
